import ArticlePage from "@/pages/article/ArticlePage";

export default function SafetyBuyerProtection() {
  return <ArticlePage slug="safety-buyer-protection-vigorbuy" />;
}